import { configureStore } from "@reduxjs/toolkit";
import { bookApi } from "../features/books/bookApi";
import booksReducer from "../features/books/bookSlice";

export const store = configureStore({
  reducer: {
    [bookApi.reducerPath]: bookApi.reducer,
    books: booksReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(bookApi.middleware),
});
